import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { EditorModule } from '@progress/kendo-angular-editor';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { CoreModule } from '../../core/core.module';
import { AfterValueChangedDirective } from '../../core/directives/after-value-changed.directive';
import { ShivePopupDirective } from '../../core/directives/shive-popup.directive';
import { CalendarSkeletonWeekViewComponent } from '../../shared/components/skeletons/calendar/calendar-skeleton-week-view/calendar-skeleton-week-view.component';
import { SharedModule } from '../../shared/shared.module';
import { CalendarComponent } from './calendar.component';
import { CalendarControlBarComponent } from './components/calendar-control-bar/calendar-control-bar.component';
import { CalendarControlBarService } from './components/calendar-control-bar/calendar-control-bar.service';
import { CalendarHeaderComponent } from './components/calendar-header/calendar-header.component';
import { CalendarHeaderService } from './components/calendar-header/calendar-header.service';
import { NowIndicatorDirective } from './components/now-indicator/now-indicator.directive';
import { ActiveTimeBlockTimerService } from './components/time-block/active/active-time-block-timer.service';
import { SharedActiveTimeBlockService } from './components/time-block/active/shared-active-time-block.service';
import { TimeBlockDurationCalculationService } from './components/time-block/calculation/duration/time-block-duration-calculation.service';
import { NewTimeBlockGenerationService } from './components/time-block/generation/new-time-block-generation.service';
import { DialogHttpRequestHandlerService } from './components/time-block/http/dialog-http-request-handler.service';
import { TimeBlockHttpCallbackService } from './components/time-block/http/time-block-http-callback.service';
import { TimeBlockModule } from './components/time-block/time-block.module';
import { OverflowingTimeBlockMonthViewDialogComponent } from './dialogs/overflowing-time-block-month-view-dialog/overflowing-time-block-month-view-dialog.component';
import { AbsencePopupComponent } from './dialogs/time-entry-dialog/absence-type-dialog/absence-popup/absence-popup.component';
import { AbsenceTypeDialogComponent } from './dialogs/time-entry-dialog/absence-type-dialog/absence-type-dialog.component';
import { AppointmentTypeDialogComponent } from './dialogs/time-entry-dialog/appointment-type-dialog/appointment-type-dialog.component';
import { ProjectTypeDialogComponent } from './dialogs/time-entry-dialog/project-type-dialog/project-type-dialog.component';
import { TimeEntryDialogComponent } from './dialogs/time-entry-dialog/time-entry-dialog.component';
import { CalendarInteractionDirective } from './interaction/calendar-interaction.directive';
import { CalendarInteractionService } from './interaction/calendar-interaction.service';
import { CalendarMouseHandlerService } from './mouse/calendar-mouse-handler.service';
import { HourAndMinutePipe } from './pipes/hour-and-minute.pipe';
import { MonthAndYearPipe } from './pipes/month-and-year.pipe';
import { CalendarDayOrWeekViewService } from './services/calendar-day-or-week-view.service';
import { CalendarGeometryService } from './services/calendar-geometry.service';
import { CalendarScrollbarService } from './services/calendar-scrollbar.service';
import { CalendarViewHandlerService } from './services/calendar-view-handler.service';
import { CalendarService } from './services/calendar.service';
import { WINDOW_PROVIDERS } from './util/browser-window-ref';
import { DayViewComponent } from './views/day/day-view.component';
import { MonthViewComponent } from './views/month/month-view.component';
import { WeekViewComponent } from './views/week/week-view.component';

@NgModule({
  imports: [
    TimeBlockModule,
    CommonModule,
    CoreModule,
    SharedModule,
    NgOptimizedImage,
    AfterValueChangedDirective,
    ShivePopupDirective,
    EditorModule,
    CalendarSkeletonWeekViewComponent,
    TooltipDirective,
  ],
  declarations: [
    CalendarComponent,
    CalendarHeaderComponent,
    CalendarControlBarComponent,
    WeekViewComponent,
    NowIndicatorDirective,
    DayViewComponent,
    MonthViewComponent,
    CalendarInteractionDirective,
    TimeEntryDialogComponent,
    MonthAndYearPipe,
    HourAndMinutePipe,
    ProjectTypeDialogComponent,
    AbsenceTypeDialogComponent,
    AppointmentTypeDialogComponent,
    AbsencePopupComponent,
    OverflowingTimeBlockMonthViewDialogComponent,
  ],
  exports: [CalendarComponent, AbsenceTypeDialogComponent],
  providers: [
    WINDOW_PROVIDERS,
    CalendarInteractionService,
    NewTimeBlockGenerationService,
    CalendarService,
    ActiveTimeBlockTimerService,
    TimeBlockDurationCalculationService,
    CalendarGeometryService,
    CalendarViewHandlerService,
    CalendarControlBarService,
    CalendarMouseHandlerService,
    DialogHttpRequestHandlerService,
    TimeBlockHttpCallbackService,
    CalendarHeaderService,
    CalendarScrollbarService,
    SharedActiveTimeBlockService,
    CalendarDayOrWeekViewService,
  ],
})
export class CalendarModule {}
